import Vue from 'vue'
import Unicon from 'vue-unicons/dist/vue-unicons-vue2.umd'

// to use specific icons globally, must import AND add here:
//
// import { uniConstructor, uniCarWash } from 'vue-unicons/src/icons'
// Unicon.add([uniConstructor, uniCarWash])

import {
  uniAngleDown,
  uniAngleLeft,
  uniAngleRight,
  uniArrowCircleLeft,
  uniArrowFromRight,
  uniArrowLeft,
  uniCheckCircle,
  uniImage,
  uniTimesCircle,
  uniBars,
  uniBill,
  uniBell,
  uniBookOpen,
  uniCamera,
  uniCheck,
  uniCheckSquare,
  uniCircle,
  uniClipboard,
  uniClipboardAlt,
  uniClipboardNotes,
  uniClock,
  uniCloudDatabaseTree,
  // uniCode,
  uniCog,
  uniCommentQuestion,
  uniDashboard,
  uniDocumentInfo,
  uniEye,
  uniExclamationTriangle,
  uniExchange,
  uniExternalLinkAlt,
  uniFileCheck,
  uniFileEditAlt,
  uniFilesLandscapes,
  uniFilePlus,
  uniInfoCircle,
  uniLeftArrowToLeft,
  uniLocationPoint,
  uniLock,
  uniMessage,
  uniMinusCircle,
  uniPadlock,
  uniPlusCircle,
  uniRedo,
  uniRepeat,
  uniSearch,
  uniShutterAlt,
  uniSignOutAlt,
  uniSignRight,
  uniStore,
  uniTimes,
  uniTrashAlt,
  uniTruck,
  uniTruckLoading,
  uniUser
  // uniUserCheck
} from 'vue-unicons/dist/icons'

Unicon.add([
  uniAngleDown,
  uniAngleLeft,
  uniAngleRight,
  uniArrowCircleLeft,
  uniArrowFromRight,
  uniArrowLeft,
  uniCheckCircle,
  uniImage,
  uniTimesCircle,
  uniBars,
  uniBill,
  uniBell,
  uniBookOpen,
  uniCamera,
  uniCheck,
  uniCheckSquare,
  uniCircle,
  uniClipboard,
  uniClipboardAlt,
  uniClipboardNotes,
  uniClock,
  uniCloudDatabaseTree,
  // uniCode,
  uniCog,
  uniCommentQuestion,
  uniDashboard,
  uniDocumentInfo,
  uniExclamationTriangle,
  uniExchange,
  uniExternalLinkAlt,
  uniEye,
  uniFileCheck,
  uniFileEditAlt,
  uniFilesLandscapes,
  uniFilePlus,
  uniInfoCircle,
  uniLeftArrowToLeft,
  uniLocationPoint,
  uniLock,
  uniMessage,
  uniMinusCircle,
  uniPadlock,
  uniPlusCircle,
  uniRedo,
  uniRepeat,
  uniSearch,
  uniShutterAlt,
  uniSignOutAlt,
  uniSignRight,
  uniStore,
  uniTimes,
  uniTrashAlt,
  uniTruck,
  uniTruckLoading,
  uniUser
  // uniUserCheck
])

Vue.use(Unicon, { height: '100%', width: '100%', fill: 'currentColor' })

//export default Unicons
